export default __webpack_public_path__ + "static/media/Software issues.dacf0504.png";